@if (shopHeader() && headerSlimFacadeService.navSlimDetails()) {
  <idp-nav-slim-links
    [shopContent]="headerSlimFacadeService.navSlimDetails()"
    (modifyButtonClicked)="onClick($event)"
  ></idp-nav-slim-links>
}

@if (vacationHeader() && vacationHeaderFacadeService.vacationSearchContent()) {
  <idp-nav-slim-links
    [vacationContent]="vacationHeaderFacadeService.vacationSearchContent()"
    [startOverVacation]="startOverVacation()"
    (modifyButtonClicked)="onClick($event)"
    (startOverButtonClicked)="startOverButtonClicked()"
  ></idp-nav-slim-links>
}
